import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import ProductForm from "./ProductForm";

const AddProduct = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box py={2}>
        <Typography variant='h5' gutterBottom>
          Add Product
        </Typography>
        <ProductForm />
      </Box>
      <Footer />
    </DashboardLayout>
  );
};

export default AddProduct;
